import React from "react";
import { EmailIcon } from "../Icons";
import { Outlet } from "react-router-dom";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { fetchActionsUtil } from "../../utils/helpers";
export default function EmailCampaignWrapper({ Nav }) {
  const { token, backendUrl } = useAuth();

  const { data } = useQuery(
    ["EMAIL_CAMPAIGN_STATS"],
    () =>
      fetchActionsUtil(`${backendUrl}/api/customers/all-email-stats`, "GET"),
    {
      keepPreviousData: true,
    },
  );

  return (
    <main className="invoice-wrapper ">
      <section className=" stats mb-3">
        <div className="stat">
          <div className="icon bg-light-blue text-primary">
            <EmailIcon />
          </div>
          <div className="details">
            <p>{data?.data?.manualEmailCount || 0}</p>
            <span>Total Manually Sent Eml</span>
          </div>
        </div>
        <div className="stat">
          <div className="icon bg-light-blue">
            <EmailIcon />
          </div>
          <div className="details">
            <p>{data?.data?.scheduledEmailCount || 0}</p>
            <span>Total Scheduled Email Sent</span>
          </div>
        </div>
        <div className="stat">
          <div className="icon bg-light-blue">
            <EmailIcon />
          </div>
          <div className="details">
            <p>{data?.data?.autoEmailCount || 0}</p>
            <span>Total Automated Emails Sent</span>
          </div>
        </div>
      </section>

      {Nav && <div className="nav-bar">{Nav}</div>}
      <Outlet />
    </main>
  );
}
